import { render, staticRenderFns } from "./ContactFiles.vue?vue&type=template&id=3a5b7711&"
import script from "./ContactFiles.vue?vue&type=script&lang=js&"
export * from "./ContactFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports